<template>
  <div>
    <BaseTitle :title="$t('content.class_list')" />
    <v-row v-if="user.cerdasTypeId === 2 || user.cerdasTypeId === null">
      <v-col v-for="item in items" :key="item.classroomId" md="4">
        <div class="class-item" @click="gotoPage(item)">
          <svg-icon icon="class" width="130" height="90" />
          <strong class="class-item-name"
            >{{ $t('menu.class') }} {{ item.name }} <br /><span class="tahun-ajaran"
              >{{ $t('form.schoolyear') }} {{ item.yearPeriode }}
            </span></strong
          >
        </div>
      </v-col>
    </v-row>
    <v-row v-if="items.length && user.cerdasTypeId === 1">
      <v-col v-for="item in items" :key="item.classroomId" md="4">
        <div class="class-item d-flex justify-space-between" @click="gotoPage(item)">
          <svg-icon icon="class" width="130" height="90" />
          <strong class="class-item-name"
            >{{ $t('menu.class') }} {{ item.classroomName }} <br /><span class="tahun-ajaran"
              >{{ $t('form.schoolyear') }} {{ item.yearPeriode }}
            </span>
          </strong>

          <br />
          <template v-if="items.length && user.cerdasTypeId === 1 && type === 'teacher'">
            <div class="pa-5">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <span dark v-bind="attrs" v-on="on">
                    <svg-icon icon="ic-moreaction-black" class="mt-1" />
                  </span>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title class="text-dropdown" @click="editDetail(item)">{{ $t('edit') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.haveStudent === false || item.status === false">
                    <v-list-item-title class="text-dropdown-delete" @click="dialogdelete(item)">{{ $t('table.delete') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </div>
      </v-col>
    </v-row>
    <!-- add class button -->
    <div class="pa-5 fixed-card" v-if="items.length && user.cerdasTypeId === 1 && type === 'teacher'">
      <v-row>
        <v-col md="9" class="mt-2">
          <span class="succ-heading mr-2"> {{ $t('content.add_class_title') }} !</span>
          <span>{{ $t('content.add_class_content_1') }}</span>
        </v-col>
        <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2 mt-3 " @click="dialogPopUp = true">{{ $t('content.add_class') }}</v-btn>
      </v-row>
    </div>
    <div class="pa-5 fixed-card" v-if="items.length && user.cerdasTypeId === 1 && type === 'student'">
      <v-row>
        <v-col md="10" class="mt-2">
          <span class="succ-heading mr-2"> {{ $t('content.join_class_title') }} !</span>
          <span>{{ $t('content.join_class_content') }}</span>
        </v-col>
        <v-col md="2">
          <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="dialogPopUpStudent = true">{{
            $t('content.join_class')
          }}</v-btn></v-col
        >
      </v-row>
    </div>
    <div v-if="(!items.length && user.cerdasTypeId === 2) || (!items.length && user.cerdasTypeId === null)">
      <div class="succ-content">
        <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
        <h1 class="succ-heading">{{ $t('nodata_title') }}</h1>
        <div class="succ-content mb-8">{{ $t('nodata_body') }}</div>
      </div>
    </div>

    <!-- not found class -->
    <div class="succ" v-if="!items.length && user.cerdasTypeId === 1 && type === 'teacher'">
      <div class="succ-content">
        <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
        <h1 class="succ-heading">{{ $t('content.add_class_title') }}</h1>
        <div class="succ-content">{{ $t('content.add_class_content') }}</div>
        <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="dialogPopUp = true">{{ $t('content.add_class') }}</v-btn>
      </div>
    </div>
    <div class="succ" v-if="!items.length && user.cerdasTypeId === 1 && type === 'student'">
      <div class="succ-content">
        <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
        <h1 class="succ-heading">{{ $t('content.join_class') }} Here!</h1>
        <div class="succ-content">{{ $t('content.join_class_teacher') }}</div>
        <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="dialogPopUpStudent = true">{{
          $t('content.join_class')
        }}</v-btn>
      </div>
    </div>

    <!-- Dialog Class Lite -->
    <v-dialog v-model="dialogPopUp" persistent max-width="607">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t('content.add_class') }}
        </v-card-title>
        <v-card-subtitle class="headline d-flex justify-center pa-5">
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <form-group :name="$t('table.grade')" :validator="$v.form.gradeName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    :disabled="form.haveStudent === true"
                    v-model="form.gradeName"
                    v-bind="attrs"
                    :label="$t('table.grade')"
                    @input="$v.form.gradeName.$touch()"
                    @blur="$v.form.gradeName.$touch()"
                  />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <form-group :name="$t('content.classroom')" :validator="$v.form.classroomName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    :disabled="form.haveStudent === true"
                    v-model="form.classroomName"
                    v-bind="attrs"
                    :label="$t('content.classroom')"
                    @input="$v.form.classroomName.$touch()"
                    @blur="$v.form.classroomName.$touch()"
                  />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <form-group :name="$t('form.schoolyear')" :validator="$v.form.yearPeriode">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    :disabled="form.haveStudent === true"
                    v-model="form.yearPeriode"
                    v-bind="attrs"
                    :label="$t('form.schoolyear')"
                    @input="$v.form.yearPeriode.$touch()"
                    @blur="$v.form.yearPeriode.$touch()"
                  />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <form-group :name="$t('form.status')" :validator="$v.form.status">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="status"
                    :label="$t('form.status')"
                    v-bind="attrs"
                    v-model="form.status"
                    width="100"
                    @input="$v.form.status.$touch()"
                    @blur="$v.form.status.$touch()"
                  >
                    <template #item="{item}">
                      {{ $t(item.text) }}
                    </template>
                    <template #selection="{item}">
                      {{ $t(item.text) }}
                    </template>
                  </v-select>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="12" class="py-0" v-if="statusModal === false">
              <form-group :name="$t('menu.course')" :validator="$v.form.courseId">
                <template slot-scope="{ attrs }">
                  <v-select
                    :disabled="form.haveStudent === true"
                    v-model="form.courseId"
                    v-bind="attrs"
                    item-value="courseId"
                    item-text="name"
                    :items="listCourse"
                    :label="$t('menu.course')"
                    @input="$v.form.courseId.$touch()"
                    @blur="$v.form.courseId.$touch()"
                  />
                </template>
              </form-group>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="closePopup">{{ $t('back') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" type="submit" @click="addClass">{{ $t('submit') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Join Class lite -->
    <v-dialog v-model="dialogPopUpStudent" persistent max-width="607">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t('content.join_class') }}
        </v-card-title>
        <v-card-subtitle class="headline d-flex justify-center pa-5">
          <v-row>
            <v-col cols="12" md="12" class="py-0">
              <div class="join-class pa-3 mt-2 mb-2">
                <strong class="text-join">{{ $t('content.join_class_teacher') }}</strong>
              </div>
            </v-col>
            <v-col cols="12" md="12" class="py-0">
              <form-group :name="$t('content.referral')" :validator="$v.formStudent.referalCode">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="formStudent.referalCode"
                    v-bind="attrs"
                    :label="$t('content.referral')"
                    @input="$v.formStudent.referalCode.$touch()"
                    @blur="$v.formStudent.referalCode.$touch()"
                  />
                </template>
              </form-group>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="closePopup">{{ $t('back') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" type="submit" @click="joinClass">{{ $t('submit') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Delete Class -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDelete">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="loading" @click="deleteDetail">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Success -->
    <v-dialog v-model="dialogPopUpSuc" persistent max-width="800">
      <v-card>
        <div class="d-flex justify-center">
          <svg-icon icon="succ-add" class="mt-10 mb-10" width="200" height="120" />
        </div>
        <v-card-title class="headline d-flex justify-center">{{ $t('content.dialog_join_title') }} </v-card-title>
        <v-card-text class="d-flex justify-center">{{ $t('content.dialog_join_body') }}</v-card-text>
        <v-card-text class="d-flex justify-center">
          <v-btn color="primary" class="btn-primary-custom" @click="dialogPopUpSuc = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import wordPunctuation from '@/validators/wordPunctuation';

export default {
  name: 'ClassList',
  props: {
    type: {
      type: String
    }
  },
  components: {
    BaseTitle
  },
  validations: function() {
    return {
      form: {
        yearPeriode: { required, wordPunctuation },
        classroomName: { required },
        courseId: this.statusModal === false ? { required } : {},
        gradeName: { required },
        status: { required }
      },
      formStudent: {
        referalCode: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      items: 'Class/items',
      student: 'Auth/student',
      isAuthenticated: 'Auth/isAuthenticated',
      user: 'Auth/user',
      status: 'Reference/itemStatus'
    })
  },
  watch: {
    student: {
      deep: true,
      handler() {
        if (this.isAuthenticated) {
          this.getData();
        }
      }
    }
  },
  data: () => ({
    loading: true,
    dialogPopUp: false,
    dialogDelete: false,
    dialogPopUpStudent: false,
    dialogPopUpSuc: false,
    form: {
      classroomName: '',
      courseId: '',
      gradeName: '',
      yearPeriode: '',
      status: '',
      haveStudent: ''
    },
    formStudent: {
      referalCode: ''
    },
    listCourse: [],
    search: '',
    classroomId: '',
    itemClass: '',
    statusModal: false
  }),
  methods: {
    closePopup() {
      this.form.classroomName = '';
      this.form.courseId = '';
      this.form.gradeName = '';
      this.form.referalCode = '';
      this.form.yearPeriode = '';
      this.form.status = '';
      this.form.haveStudent = '';
      this.dialogPopUp = false;
      this.statusModal = false;
      this.dialogPopUpStudent = false;
    },
    addClass() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return false;
      }

      this.loading = true;
      const payload = { ...(this.classroomId ? { id: this.classroomId } : null), ...this.form };

      this.$store
        .dispatch(`Class/${this.statusModal === false ? 'savelite' : 'updatelite'}`, payload)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.loading = false;
          this.dialogPopUp = false;
          this.statusModal = false;
          this.form.haveStudent = '';
          this.getDataLite();
          this.form.classroomName = '';
          this.form.courseId = '';
          this.form.gradeName = '';
          this.form.referalCode = '';
          this.form.yearPeriode = '';
          this.form.status = '';
          this.$v.$reset();
        });
    },
    joinClass() {
      this.$v.formStudent.$touch();
      if (this.$v.formStudent.$invalid) {
        return false;
      }

      this.loading = true;
      const payload = { ...this.formStudent };

      this.$store
        .dispatch(`Class/joinClass`, payload)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          if (data) {
            this.dialogPopUpSuc = true;
          }
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.loading = false;
          this.dialogPopUpStudent = false;
          this.statusModal = false;
          this.getDataLite();
          this.formStudent.referalCode = '';
          this.$v.$reset();
        });
    },
    editDetail(item) {
      this.$store.dispatch('Class/fetchListLiteDetail', item.classroomId).then(res => {
        Object.keys(this.form).forEach(form => {
          this.form[form] = res[form];
          this.form.haveStudent = item.haveStudent;
        });
        this.statusModal = true;
        this.dialogPopUp = true;
        this.classroomId = res.classroomId;
      });
    },
    getData() {
      let action = '';
      switch (this.type) {
        case 'teacher':
          action = 'Class/fetchList';
          break;
        case 'student':
          action = 'Class/fetchListStudent';
          break;
        case 'parent':
          action = 'Class/fetchListParent';
          break;
      }
      this.loading = true;
      this.$store.dispatch(action, this.student).finally(() => (this.loading = false));
    },
    getCourselite() {
      this.loading = true;
      this.$store
        .dispatch(`CourseSchool/fetchListLite`, {
          search: this.search
        })
        .then(data => (this.listCourse = data))
        .finally(() => (this.loading = false));
    },
    getDataLite() {
      let action = '';
      switch (this.type) {
        case 'teacher':
          action = 'Class/fetchListLite';
          break;
        case 'student':
          action = 'Class/fetchListStudentLite';
          break;
      }
      this.loading = true;
      this.$store.dispatch(action, this.student).finally(() => (this.loading = false));
    },
    gotoPage({ classroomId }) {
      const classId = classroomId;
      switch (this.type) {
        case 'teacher':
          this.$router.push({ name: 'TeacherCourseList', params: { classId } });
          break;
        case 'parent':
          this.$router.push({ name: 'ParentCourseIndex', params: { classId } });
          break;
        case 'student':
          this.$router.push({ name: 'StudentCourseIndex', params: { classId } });
          break;
      }
    },
    dialogdelete(item) {
      this.itemClass = item;
      this.dialogDelete = true;
    },
    cancelDelete() {
      this.dialogDelete = false;
      this.itemClass = null;
    },
    deleteDetail() {
      this.loading = true;
      this.$store
        .dispatch('Class/destroy', this.itemClass)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getDataLite();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    }
  },
  created() {
    if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
      this.getData();
    } else {
      if (this.user.cerdasTypeId === 1 && this.type === 'teacher') {
        this.getDataLite();
        this.getCourselite();
      } else {
        this.getDataLite();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.class-item {
  display: flex;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
  background: #fff;
  padding: 20px;
  cursor: pointer;

  &:hover {
    background: #f8f8f8;
  }

  &-name {
    word-break: break-all;
    width: fit-content;
  }
}
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}

.tahun-ajaran {
  color: #ce8800;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
  &-grey {
    color: grey;
    cursor: pointer;
  }
}

.fixed-card {
  position: absolute;
  bottom: 0;
  background-color: #ffffff;
  width: 74%;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
}

.join-class {
  background-color: #eef6fc;
  border-radius: 8px;
}

.text-join {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
}
.guide-card-text {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 13px;
  line-height: 14px;
  text-align: left;
}
</style>
